// @ts-ignore
import { Grid2, Box, Typography, TextField, Button } from '@mui/material';

import React from 'react';
import './Footer.css'

import myImage from '../../assets/images/cards.png'
import Lights from '../../assets/images/emailBox.png'
import Logo from '../../assets/images/Logo.png'

const Footer: React.FC = () => {
  return (
      <Grid2 id='email-container' container justifyContent="center" alignItems="center">
        <Grid2 className='inner-container1' container justifyContent="center" alignItems="center"
               columns={{xs: 10}}
               size={{xs:10}}
        >
            <Grid2 className='email-box'
                   size={{xs:10}}
                   spacing={{xs: 1, md: 2}}
                   container justifyContent="center" alignItems="center"
            >
                <Grid2 className='news-text-box' size={{xs: 10, md: 5}} justifyContent="center" alignItems="center">
                    <Typography className='text-h2'>Be the first to get the news</Typography>
                    <Typography className='text-h1'>The latest news and blog sent to your inbox weekly.</Typography>
                </Grid2>
                
                <Grid2 className='news-text-box' size={{xs: 10, md: 5}} justifyContent="center" alignItems="center">
                    <Box className='email-input'> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                            <path d="M12.2968 5.14331L12.3003 5.14039C12.7747 4.75502 12.8506 4.05204 12.4694 3.57466C12.086 3.07734 11.3725 3.01297 10.8998 3.39505L8.57322 5.25337L8.57219 5.2542C8.40633 5.38733 8.15536 5.47168 7.87634 5.47168C7.59732 5.47168 7.34636 5.38733 7.1805 5.2542L7.17946 5.25337L4.85291 3.39511C4.36391 2.99971 3.66656 3.10296 3.28932 3.56725L3.28268 3.57559C2.91135 4.05089 2.98368 4.75358 3.45975 5.14039L3.46339 5.14331L5.7894 7.00116C6.38628 7.48681 7.1474 7.71236 7.88006 7.71236C8.61594 7.71236 9.36783 7.48506 9.96926 7.00233C9.96907 7.00247 9.96945 7.00218 9.96926 7.00233L12.2968 5.14331ZM4.16111 0.735596H11.599C12.6292 0.735596 13.4024 0.993219 13.9156 1.4698C14.4215 1.93941 14.7601 2.7014 14.7601 3.89671V9.1033C14.7601 10.2985 14.4215 11.0605 13.9156 11.5301C13.4024 12.0068 12.6292 12.2644 11.599 12.2644H4.16111C3.13094 12.2644 2.35768 12.0068 1.84445 11.5301C1.33871 11.0605 1 10.2985 1 9.1033V3.89671C1 2.7014 1.33871 1.93941 1.84445 1.4698C2.35768 0.993219 3.13094 0.735596 4.16111 0.735596Z" fill="black"/>
                            <path d="M9.96926 7.00233C9.36783 7.48506 8.61594 7.71236 7.88006 7.71236C7.1474 7.71236 6.38628 7.48681 5.7894 7.00116L3.46339 5.14331L3.45975 5.14039C2.98368 4.75358 2.91135 4.05089 3.28268 3.57559L3.28932 3.56725C3.66656 3.10296 4.36391 2.99971 4.85291 3.39511L7.17946 5.25337L7.1805 5.2542C7.34636 5.38733 7.59732 5.47168 7.87634 5.47168C8.15536 5.47168 8.40633 5.38733 8.57219 5.2542L8.57322 5.25337L10.8998 3.39505C11.3725 3.01297 12.086 3.07734 12.4694 3.57466C12.8506 4.05204 12.7747 4.75502 12.3003 5.14039L12.2968 5.14331L9.96926 7.00233ZM9.96926 7.00233C9.96945 7.00218 9.96907 7.00247 9.96926 7.00233ZM4.16111 0.735596H11.599C12.6292 0.735596 13.4024 0.993219 13.9156 1.4698C14.4215 1.93941 14.7601 2.7014 14.7601 3.89671V9.1033C14.7601 10.2985 14.4215 11.0605 13.9156 11.5301C13.4024 12.0068 12.6292 12.2644 11.599 12.2644H4.16111C3.13094 12.2644 2.35768 12.0068 1.84445 11.5301C1.33871 11.0605 1 10.2985 1 9.1033V3.89671C1 2.7014 1.33871 1.93941 1.84445 1.4698C2.35768 0.993219 3.13094 0.735596 4.16111 0.735596Z" stroke="black" stroke-width="1.11569"/>
                        </svg>
                        <TextField
                        sx={{
                            '& .MuiInputBase-input':{
                                color:'#000 !important',

                            }
                        }}
                        placeholder='Your Email'></TextField>
                        <Button className='email-input-button'>Subscribe</Button>
                    </Box>
                </Grid2>

                <Box className='cards-img'>
                    <img className='cards_layout' src={myImage} alt="" />
                </Box>
            </Grid2>
            <Box className='lights-img'>
            </Box>
        </Grid2>



        <Grid2 className='inner-container2'>
            <img id='logo-img' src={Logo} alt="No image" />
            <Box>
                <Box className='rights_box'>
                    <Typography>© 8RABBITS 2025. All rights reserved.</Typography>
                </Box>
                <Box className='text_privacy'>
                    <Typography>Privacy policy</Typography>
                    <Typography>Cookies</Typography>
                </Box>
            </Box>
        </Grid2>
    </Grid2>
  );
};

export default Footer;